import { createBasicLoopbackRepository as createRepository } from 'elentari'
import { restApi } from '../../../services/Api'

const anexosRepository = createRepository({
  parentPath: 'blacklist-kmm',
  path: 'anexos',
  relationType: 'path',
  restApi
})

anexosRepository.uploadAnexos = (blacklistKmmId, data, file) => {
  const formData = new FormData()
  formData.append('file', file)
  formData.append('data', JSON.stringify(data))
  return restApi.post(`blacklist-kmm/${blacklistKmmId}/anexos`, formData, {
    header: {
      Accept: 'application/json',
      'Content-Type': 'multipart/form-data'
    }
  })
}

export default anexosRepository
